'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _cbSiteHeader = require('./cb-site-header.directive');

var _cbSiteHeader2 = _interopRequireDefault(_cbSiteHeader);

var _siteHeader = require('./site-header.controller');

var _siteHeader2 = _interopRequireDefault(_siteHeader);

var _cbUserPrefsContainer = require('./cb-user-prefs-container.directive');

var _cbUserPrefsContainer2 = _interopRequireDefault(_cbUserPrefsContainer);

var _cbUserPrefs = require('./cb-user-prefs.controller');

var _cbUserPrefs2 = _interopRequireDefault(_cbUserPrefs);

var _cbUserPrefs3 = require('./cb-user-prefs.directive');

var _cbUserPrefs4 = _interopRequireDefault(_cbUserPrefs3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.ui-components.site-header', [_cbSiteHeader2.default.name, _siteHeader2.default.name, _cbUserPrefsContainer2.default.name, _cbUserPrefs2.default.name, _cbUserPrefs4.default.name]).constant('HeaderConstants', {
    FONDSBELEGGEN_URL: 'https://beleggen.centraalbeheer.nl/mijn-producten',
    FONDSBELEGGEN_URL_ACC: 'https://acc-beleggen.centraalbeheer.nl/mijn-producten'
});

exports.default = _module;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/site-header/index.js
// module id = 909
// module chunks = 0